<template>
  <div class="invite">
    <div class="page">
      <InviteHeader
        @back-click="goBack"
      />
      <div class="mt-8">
        <InviteTabBar
          :currentTab="currentTab"
          @tab-change="onTabChange"
        />
      </div>

      <!-- 초대하기 탭 -->
      <InviteShareTab
        v-if="currentTab === 'invite'"
        :inviteCode="inviteCode"
        :friendCount="friendCount"
        :friends="friends"
        @friend-list-open="fetchInviteFriends"
        @kakao-click="shareKakao"
        @link-click="copyInviteLink"
      />

      <!-- 초대코드 입력 탭 -->
      <InviteCodeTab
        v-if="currentTab === 'code'"
        :inputCode="inputCode"
        :hasError="hasError"
        :errorMessage="errorMessage"
        :isAlreadyReferred="isAlreadyReferred"
        :notEligible="notEligible"
        :rewardStatus="rewardStatus"
        @input="onInputCode"
        @submit="submitCode"
      />

      <!-- fix 하단 버튼 영역 (초대하기 탭에서만 노출) -->
      <InviteBottomBar
        v-if="currentTab === 'invite'"
        @kakao-click="shareKakao"
        @link-click="copyInviteLink"
      />
      <!-- 토스트 -->
      <div class="toast" v-if="toastMessage">{{ toastMessage }}</div>
    </div>
  </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';
import Constant from '@/constant';

import InviteHeader from '@/components/new/molecules/InviteHeader.vue'
import InviteTabBar from '@/components/new/molecules/InviteTabBar.vue'
import InviteShareTab from '@/components/new/organisms/InviteShareTab.vue'
import InviteCodeTab from '@/components/new/organisms/InviteCodeTab.vue'
import InviteBottomBar from '@/components/new/molecules/InviteBottomBar.vue'

export default {
  name: 'Invite',
  components: {
    InviteHeader,
    InviteTabBar,
    InviteShareTab,
    InviteCodeTab,
    InviteBottomBar,
  },
  data() {
    return {
      currentTab: 'invite',
      inviteCode: '',
      friendCount: 0,
      friends: [],
      inputCode: '',
      access_token: null,
      isAlreadyReferred: false,
      notEligible: false,
      rewardStatus: '',
      hasError: false,
      errorMessage: '',
      toastMessage: '',
    }
  },
  mounted() {
    ChannelIO('shutdown')
    const code = this.$route.query.code;
    if (code) {
      this.currentTab = 'code';
      this.inputCode = code;
    }

    this.access_token = cookies.getLocalStorage("access_token");
    if (this.access_token === null || this.access_token === undefined || this.access_token === '') {
      this.access_token = cookies.deleteLocalStorage("access_token");
      this.$router.push({path: '/', query: {returnUrl: 'invite', code: code || undefined}})
    } else {
      this.fetchInviteCode();
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/home' })
    },
    onTabChange(tab) {
      this.currentTab = tab
    },
    onInputCode(val) {
      this.inputCode = val
      if (this.hasError) {
        this.hasError = false
        this.errorMessage = ''
      }
    },
    copyInviteLink() {
      var link = process.env.LOGIN_URI + '/invite?code=' + (this.inviteCode || '');
      var message = '[솔닥 컨시어지]\n'
        + '병원 갈 필요 없이 전화로 진료 받을 수 있어요.\n\n'
        + '연속혈당측정기 첫 구매 시 네이버페이 3만원 혜택을 드려요!\n\n'
        + '솔닥 컨시어지 이용하기: ' + link;
      navigator.clipboard.writeText(message).then(() => {
        this.showToastMessage('복사가 완료되었습니다');
      });
    },
    shareKakao() {
      var link = process.env.LOGIN_URI + '/invite?code=' + (this.inviteCode || '');
      Kakao.Share.sendDefault({
        objectType: 'feed',
        content: {
          title: '병원 갈 필요 없이 전화로 진료 받을 수 있어요.',
          description: '연속혈당측정기 첫 구매 시 네이버페이 3만원 혜택을 드려요!',
          imageUrl: 'https://baro.soldoc.co.kr/thumbnail.png',
          link: {
            mobileWebUrl: link,
            webUrl: link
          }
        },
        buttons: [
          {
            title: '초대 받기',
            link: {
              mobileWebUrl: link,
              webUrl: link
            }
          }
        ]
      });
    },
    submitCode() {
      if (!this.inputCode || this.isAlreadyReferred) return;
      // 영문/숫자 8자리가 아닌 경우 (공백, 한글 포함 또는 길이 불일치)
      if (!/^[A-Za-z0-9]{8}$/.test(this.inputCode)) {
        this.hasError = true;
        this.errorMessage = '숫자,영어 8글자를 입력해주세요.';
        return;
      }
      this.$store.dispatch(Constant.APPLY_INVITE_CODE, {code: this.inputCode, token: this.access_token})
        .then(() => {
          this.hasError = false;
          this.errorMessage = '';
          this.fetchInviteCode(true);
        })
        .catch(() => {
          this.hasError = true;
          this.errorMessage = '초대 코드가 일치하지 않아요. 코드를 다시 확인해 주세요.';
        })
    },
    fetchInviteCode(showToast) {
      this.$store.dispatch(Constant.FETCH_INVITE_CODE, {token: this.access_token})
        .then((res) => {
          if (res && res.data) {
            this.inviteCode = res.data.referral_code || '';
            this.friendCount = res.data.referral_count || 0;
            this.rewardStatus = res.data.referral_reward_status || '';
            if (res.data.referred_by_code !== null && res.data.referred_by_code !== '' && res.data.referred_by_code !== undefined) {
              this.isAlreadyReferred = true;
              this.notEligible = false;
              this.inputCode = res.data.referred_by_code;
              if (showToast) {
                this.showToastMessage('등록이 완료되었습니다.');
              }
              if (this.$route.query.code) {
                // this.access_token = cookies.deleteLocalStorage("access_token");
                this.$router.replace({path: '/invite', query: {}});
              }
            } else {
              this.isAlreadyReferred = false;
              this.notEligible = res.data.can_register_referral === false;
            }
          }
        })
        .catch(() => {
          this.access_token = cookies.deleteLocalStorage("access_token");
          this.$router.push({path: '/', query: {returnUrl: 'invite'}})
        })
    },
    fetchInviteFriends() {
      this.$store.dispatch(Constant.FETCH_INVITE_FRIENDS, {token: this.access_token})
        .then((res) => {
          if (res && res.data) {
            this.friends = res.data || [];
          }
        })
        .catch(() => {
          this.friends = [];
        })
    },
    showToastMessage(msg) {
      this.toastMessage = msg;
      setTimeout(() => { this.toastMessage = ''; }, 2000);
    }
  }
}
</script>

<style scoped>
    .invite {
        display: flex;
        width: 100%;
        min-height: 100vh;
        justify-content: center;
        align-items: flex-start;
    }
    .page {
        width: 100%;
        background: #FFF;
    }
    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
    .mt-8 { margin-top: 8px; }
    .mt-12 { margin-top: 12px; }
    .mt-16 { margin-top: 16px; }
    .mt-20 { margin-top: 20px; }
    .mt-24 { margin-top: 24px; }
    .mt-32 { margin-top: 32px; }
    .mt-40 { margin-top: 40px; }

    .toast {
        position: fixed;
        bottom: 120px;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(30, 30, 30, 0.85);
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        padding: 12px 24px;
        border-radius: 8px;
        z-index: 9999;
    }
</style>



// WEBPACK FOOTER //
// src/page/new/Invite.vue